import { Documentto } from '../../@types/GenerateProposalDocuments'
import { ResumePetisSimulationProposalClientResponse } from '../../@types/ResumePetisSimulationProposal'
import { DocumentsToList } from '../../@types/SimulationSummaryDownload'
import { ENV } from '../../Environment'
import { useReportStore } from '../../Stores/reportStore'
import { useSimulatorStore } from '../../Stores/simulatorStore'
import { useGenerateProposalDocumentsStore } from '../../Stores/useGenerateProposalDocumentsStore'
import { useSimulationSummaryDownloadStore } from '../../Stores/useSimulationSummaryDownloadStore'

const REDIRECTION_STEP_CODE_SIMULATION = '20'

export const useDocumentsToListHydration = () => {
  const { setSimulationSummaryDownload } = useSimulationSummaryDownloadStore()
  const { setGenerateProposalDocuments } = useGenerateProposalDocumentsStore()
  const { setIsReportGeneratedEnabled } = useReportStore()
  const { setHasGenerateProposal } = useSimulatorStore()

  const handleDocumentsToListHydration = (
    data: ResumePetisSimulationProposalClientResponse,
  ) => {
    if (data.redirectionStepCode === REDIRECTION_STEP_CODE_SIMULATION) {
      setSimulationSummaryDownload({
        documentsToList: data.processData?.documentList as DocumentsToList[],
      })
    } else {
      setGenerateProposalDocuments({
        documentstoList: data.processData?.documentList as Documentto[],
      })
    }

    if ((data.processData?.documentList || [])?.length) {
      const disabledGenerateProposalDocuments =
        (
          data.processData?.documentList?.filter(
            (doc) => doc?.documentCode === ENV().documentCode,
          ) || []
        )?.length > 0

      setIsReportGeneratedEnabled(false)
      setHasGenerateProposal(disabledGenerateProposalDocuments)
    }
  }

  return { handleDocumentsToListHydration }
}
